import React from 'react';
import { useConfig } from 'context/ConfigContext.js'; // Correct relative path

const Footer = () => {
  const config = useConfig(); // Use the hook to get the current app's config

  return (
      <footer className="bg-gray-800 text-white py-8 px-4">
        <div className="container mx-auto text-center text-sm">
          <p className="mb-4">&copy; 2025 {config.fullCompanyName}. All rights reserved.</p>
          <div className="space-x-4">
            <a href="/legal" className="hover:underline">Legal</a>
            <a href="/terms" className="hover:underline">Terms</a>
            <a href="/privacy" className="hover:underline">Privacy</a>
          </div>
        </div>
      </footer>
  );
};

export default Footer;
